import { f as _objectSpread2, k as _asyncToGenerator, l as _regeneratorRuntime, j as _slicedToArray } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled, { withTheme } from 'styled-components';
import { T as Tooltip } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { T as Text$1 } from './index-5dfda37f-a2c0763c.js';
import { L as Loader } from './loader-4d85b9a1.js';
import { D as DEFAULTS, b as CAS_URLS_MAP, C as CONSTANTS, R as ROUTES } from './constants-9315121a.js';
import { I as IconWrapper, g as getObjectValue } from './IconWrapper-f69d60c7-8a74d4d9.js';
import '@styled-system/grid';
import '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';
import Popup from './Popup.js';

// #region Action
var actionStyles = function actionStyles(props) {
  var active = props.active,
    style = props.style,
    mode = props.mode,
    locked = props.locked,
    theme = props.theme,
    disabled = props.disabled;
  var allActionStyles = {};
  var defaultStyles = {
    height: DEFAULTS.actionHeight,
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    borderRadius: theme.radii.sm,
    padding: "0 ".concat(theme.space.sm, "px"),
    border: 0,
    alignItems: "center",
    color: theme.colors.black.haptik,
    pointerEvents: active || disabled ? "none" : "all",
    "svg > circle": {
      fill: disabled ? theme.colors.grey.dark : ""
    },
    "&:hover": {
      background: "#CFE5FF4D",
      "> div:last-child": {
        path: {
          fill: locked ? theme.colors.yellow.haptik : "initial"
        }
      }
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: "100%",
      left: 2,
      height: active ? 3 : 0,
      opacity: active ? 1 : 0,
      bottom: mode === "tab" ? "-4px" : "-13px",
      background: theme.colors.blue.haptik,
      borderRadius: "".concat(theme.radii.sm, "px ").concat(theme.radii.sm, "px 0 0"),
      transition: "all 0.3s ease"
    }
  };
  if (mode === "tool") {
    allActionStyles = _objectSpread2(_objectSpread2({}, defaultStyles), {}, {
      marginRight: 18,
      "&:last-child": {
        margin: 0
      }
    });
  } else {
    allActionStyles = _objectSpread2({}, defaultStyles);
  }
  if (style && Object.keys(style).length > 0) {
    allActionStyles = _objectSpread2(_objectSpread2({}, allActionStyles), style);
  }
  return allActionStyles;
};
var StyledAction = styled(Box)(actionStyles);
// #endregion

// #region ActionIcons
var actionIconStyles = function actionIconStyles(props) {
  return {
    borderRadius: "100%",
    transition: "all 0.2s ease",
    padding: 0,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    path: {
      fill: props.theme.colors.grey.deep
    },
    ">div": {
      width: "auto",
      height: "auto"
    }
  };
};
var ActionIcon = styled(Box)(actionIconStyles);

var Action = function Action(props) {
  var children = props.children,
    mode = props.mode,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? true : _props$visible;
  if (!visible) {
    return null;
  }
  if (mode === "icon") {
    return /*#__PURE__*/React.createElement(ActionIcon, props, children);
  }
  return /*#__PURE__*/React.createElement(StyledAction, props, children);
};
Action.propTypes = {
  children: PropTypes.element,
  mode: PropTypes.string,
  visible: PropTypes.bool
};
Action.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Action",
  "props": {
    "children": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": ""
    },
    "mode": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "visible": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

/**
 * Save data in Local Storage
 */
var updateLocalStorage = function updateLocalStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
};

/**
 * Get data from Local Storage
 */
var getDataFromLocalStorage = function getDataFromLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));
};

/**
 * Debouncer
 * @param callback Function to be called
 * @param wait Execute the callback post this wait time
 *
 * Primarily used for live search in FE.
 * eg. Waits till user completed typing a keyword and will then initiate search
 * Waits till the time specified.
 */
var debounce = function debounce(callback, wait) {
  var timeoutId = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(function () {
      // eslint-disable-next-line prefer-spread
      callback.apply(null, args);
    }, wait);
  };
};

/**
 * Environment URL Utility
 * @param baseUrl Current page URL
 * Returns URL based on current env and cas
 * If staging url is detected, then its respective prod url will be returned and vice-versa
 */
var getEnvURL = function getEnvURL(baseUrl) {
  // TODO: Add logic to test this internally
  return baseUrl && CAS_URLS_MAP[baseUrl];
};
var getCookie = function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i += 1) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === "".concat(name, "=")) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};
var csrfSafeMethod = function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
};
var sameOrigin = function sameOrigin(url) {
  // test that a given url is a same-origin URL
  // url could be relative or scheme relative or absolute
  var host = document.location.host; // host + port
  var protocol = document.location.protocol;
  var srOrigin = "//".concat(host);
  var origin = protocol + srOrigin;
  // Allow absolute or scheme relative URLs to same origin
  return url === origin || url.slice(0, origin.length + 1) === "".concat(origin, "/") || url === srOrigin || url.slice(0, srOrigin.length + 1) === "".concat(srOrigin, "/") ||
  // or any other URL that isn't scheme relative or absolute i.e relative.
  !/^(\/\/|http:|https:).*/.test(url);
};

/**
 * checks whether backend has sent an error
 * @param status status code of api call
 */
var hasError = function hasError(status) {
  var ERROR_HEADERS = [400, 403, 405, 500];
  return ERROR_HEADERS.includes(status);
};
var APIRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, method) {
    var additionalHeaders, response, request, contentType, json;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          additionalHeaders = {};
          if (!csrfSafeMethod(method) && sameOrigin(url)) {
            additionalHeaders["X-CSRFToken"] = getCookie("csrftoken");
          }
          request = new Request(url, {
            method: method,
            headers: new Headers(_objectSpread2({
              "Content-Type": "application/json"
            }, additionalHeaders))
          });
          _context.prev = 3;
          _context.next = 6;
          return fetch(request);
        case 6:
          response = _context.sent;
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](3);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 12:
          _context.prev = 12;
          contentType = response.headers.get("content-type");
          if (!(contentType && contentType.indexOf("application/json") !== -1)) {
            _context.next = 23;
            break;
          }
          _context.next = 17;
          return response.json();
        case 17:
          json = _context.sent;
          if (json) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("return", Promise.reject(new Error("Invalid JSON ".concat(json))));
        case 20:
          if (!hasError(response.status)) {
            _context.next = 22;
            break;
          }
          return _context.abrupt("return", Promise.resolve({
            success: false,
            response: json,
            status: response.status
          }));
        case 22:
          return _context.abrupt("return", Promise.resolve({
            success: true,
            response: json,
            status: response.status
          }));
        case 23:
          return _context.abrupt("return", Promise.reject(new Error("API Request Failed")));
        case 26:
          _context.prev = 26;
          _context.t1 = _context["catch"](12);
          return _context.abrupt("return", Promise.reject(_context.t1));
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 9], [12, 26]]);
  }));
  return function APIRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Generates MixPanel Payload
 * @param event The event name which is to be logged
 * @param payload The payload which is to be sent along with the event
 * @returns
 */
var mixPanelPayload = function mixPanelPayload(event, payload) {
  var mixPanelData = {
    event: event
  };
  if (payload) {
    var botPartner = payload.client;
    var botBusiness = payload.isSmartSkill ? payload.business_via_name : payload.business && payload.business.length > 0 && payload.business[0].via_name;
    var payloadData = {
      "Bot Name": payload.title || payload.name,
      "Bot Business": botBusiness,
      "Is Smart Skill": payload.isSmartSkill
    };
    if (payload.searchTerm) {
      payloadData["Search Query"] = payload.searchTerm;
    }
    if (payload.envSwitchedTo) {
      payloadData["Environment Switched To"] = payload.envSwitchedTo;
    }
    if (!payload.isSmartSkill) {
      payloadData["Bot Partner"] = botPartner;
    }
    mixPanelData.payload = payloadData;
  }
  return mixPanelData;
};

var SearchIconV2 = function SearchIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2939 14.5786H15.3905L15.0703 14.2699C16.191 12.9663 16.8656 11.2739 16.8656 9.43282C16.8656 5.32762 13.538 2 9.43282 2C5.32762 2 2 5.32762 2 9.43282C2 13.538 5.32762 16.8656 9.43282 16.8656C11.2739 16.8656 12.9663 16.191 14.2699 15.0703L14.5786 15.3905V16.2939L20.2962 22L22 20.2962L16.2939 14.5786ZM9.43282 14.5786C6.58548 14.5786 4.28702 12.2802 4.28702 9.43282C4.28702 6.58548 6.58548 4.28702 9.43282 4.28702C12.2802 4.28702 14.5786 6.58548 14.5786 9.43282C14.5786 12.2802 12.2802 14.5786 9.43282 14.5786Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
SearchIconV2.propTypes = {
  iconColor: PropTypes.string
};
SearchIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var SearchIconV2$1 = withTheme(SearchIconV2);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Generic = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 3.273c.276 0 .5-.245.5-.546 0-.301-.224-.545-.5-.545s-.5.244-.5.545c0 .301.224.546.5.546zM4.5 3.273c.276 0 .5-.245.5-.546 0-.301-.224-.545-.5-.545s-.5.244-.5.545c0 .301.224.546.5.546zM6.5 3.273c.276 0 .5-.245.5-.546 0-.301-.224-.545-.5-.545s-.5.244-.5.545c0 .301.224.546.5.546z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.91h11c.276 0 .5-.245.5-.546 0-.302-.224-.546-.5-.546h-11c-.276 0-.5.244-.5.546 0 .301.224.545.5.545zM11.5 16.363h-6c-.276 0-.5.244-.5.546 0 .301.224.545.5.545h6c.276 0 .5-.244.5-.545 0-.302-.224-.546-.5-.546z",
  fill: "#030135"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5 11.5l2-2.5-.5-1.5-.5-.5L21 8l-4.5 5-1.5 1.5v2h1l1-.5 4.5-4.5z",
  fill: "#FF6A32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.086 6.545c-.029 0-.057.008-.086.01V2.182C22 .979 21.103 0 20 0H2C.897 0 0 .979 0 2.182v19.636C0 23.021.897 24 2 24h18c1.103 0 2-.979 2-2.182V11.68l1.44-1.57c.356-.39.56-.927.56-1.476 0-1.152-.858-2.089-1.914-2.089zM1 2.182c0-.602.448-1.091 1-1.091h18c.552 0 1 .49 1 1.09v2.183H1V2.182zm20 19.636c0 .601-.448 1.091-1 1.091H2c-.552 0-1-.49-1-1.09V5.454h20v1.463a1.93 1.93 0 00-.268.239l-5.44 5.934H5.5c-.276 0-.5.244-.5.545 0 .302.224.546.5.546h8.99l-.48 2.62a.577.577 0 00.136.493.48.48 0 00.452.149l2.499-.546a.486.486 0 00.256-.149L21 12.771v9.047zm-4.247-5.957l-1.615.353.323-1.764L20 9.498l1.293 1.411-4.54 4.952zm5.98-6.522l-.733.799-1.293-1.411.732-.8a.884.884 0 01.647-.29c.504 0 .914.447.914.996 0 .263-.098.52-.268.706z",
  fill: "#030135"
})));

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var Insurance = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.308 13.284l-.866-2.022a1.275 1.275 0 00-2.333 1.03l1.568 3.449c.211.466.505.891.868 1.253l2.466 2.466a.795.795 0 00-.217.544v3.2a.8.8 0 00.8.8h4.401a.8.8 0 00.8-.8v-3.2a.8.8 0 00-.8-.8v-.745a4.19 4.19 0 00-.877-2.62 2.881 2.881 0 00-1.333-.972 7.914 7.914 0 01-2.29-1.47 1.84 1.84 0 00-2.187-.113zm6.687 9.92h-4.4v-3.2h4.4v3.2zm-1.501-6.865c.466.608.713 1.355.701 2.12v.745H5.887L3.11 16.429a3.458 3.458 0 01-.706-1.02L.837 11.962a.475.475 0 11.87-.384l.895 2.087a4.72 4.72 0 001.009 1.49l1.827 1.828a.4.4 0 10.566-.566L4.176 14.59a3.942 3.942 0 01-.493-.6 1.04 1.04 0 011.296.021 8.53 8.53 0 002.553 1.616c.383.14.717.387.962.713z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.795 21.203h-.4a.4.4 0 000 .8h.4a.4.4 0 000-.8zM22.315 15.74l1.568-3.449a1.275 1.275 0 10-2.333-1.03l-.864 2.014a1.846 1.846 0 00-2.189.12 7.912 7.912 0 01-2.29 1.47 2.88 2.88 0 00-1.334.973 4.19 4.19 0 00-.877 2.62v.745a.8.8 0 00-.8.8v3.2a.8.8 0 00.8.8h4.401a.8.8 0 00.8-.8v-3.2a.795.795 0 00-.216-.544l2.465-2.465c.363-.363.657-.787.869-1.254zm-3.918 7.463h-4.4v-3.2h4.4v3.2zm-.292-4h-3.309v-.744a3.393 3.393 0 01.702-2.12c.244-.326.578-.574.96-.713a8.528 8.528 0 002.553-1.617 1.04 1.04 0 011.298-.025c-.145.218-.31.42-.495.604l-1.828 1.828a.4.4 0 00.566.566l1.827-1.828a4.719 4.719 0 001.01-1.49l.894-2.087a.475.475 0 11.87.384l-1.568 3.448c-.172.38-.411.725-.706 1.02l-2.774 2.774z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.596 21.203h-.4a.4.4 0 000 .8h.4a.4.4 0 000-.8z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.908 3.135V9.3a3.997 3.997 0 01-1.66 3.245l-4.145 2.992a.337.337 0 01-.393 0l-.404-.293-3.74-2.7A3.997 3.997 0 015.906 9.3V3.135a.184.184 0 01.111-.172l5.29-2.32.524-.228a.2.2 0 01.152 0l5.813 2.548c.069.03.113.098.112.172z",
  fill: "#E8EDFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.708 3.136V9.3a3.997 3.997 0 01-1.66 3.244l-3.742 2.7-3.74-2.7A3.997 3.997 0 015.906 9.3V3.136a.184.184 0 01.111-.172l5.29-2.32 5.289 2.32c.068.029.113.097.112.172z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.51 11.129a2.45 2.45 0 01-1.005-1.974V3.944L11.906 2l4.401 1.944v5.21a2.448 2.448 0 01-1.005 1.975L11.906 13.6 8.511 11.13z",
  fill: "#A4C2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.103 15.536l.404-.293-3.741-2.7A3.997 3.997 0 017.106 9.3V3.135a.184.184 0 01.112-.172L12.507.644l-.52-.229a.2.2 0 00-.152 0l-.525.228-5.293 2.32a.184.184 0 00-.112.172V9.3c0 1.286.618 2.493 1.66 3.245l3.741 2.7.405.292a.337.337 0 00.392 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.907 16a.731.731 0 01-.43-.14L7.33 12.87a4.405 4.405 0 01-1.825-3.563v-6.28a.4.4 0 01.24-.367L11.747.033a.4.4 0 01.32 0l6.001 2.627a.4.4 0 01.24.366v6.28a4.405 4.405 0 01-1.824 3.564l-4.148 2.991a.733.733 0 01-.43.139zM6.306 3.288v6.019a3.603 3.603 0 001.492 2.914l4.109 2.963 4.109-2.963a3.603 3.603 0 001.492-2.914v-6.02L11.907.838l-5.601 2.45z",
  fill: "#428DFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.906 14.105a.4.4 0 01-.234-.075l-3.406-2.457a2.8 2.8 0 01-1.16-2.266V4.073a.4.4 0 01.24-.366l4.4-1.927a.4.4 0 01.32 0l4.402 1.927a.4.4 0 01.24.366v5.234a2.8 2.8 0 01-1.16 2.266L12.14 14.03a.4.4 0 01-.235.075zm-3.172-3.18l3.172 2.287 3.173-2.288a2 2 0 00.828-1.617V4.334l-4-1.75-4.001 1.75v4.973a2 2 0 00.828 1.617z",
  fill: "#428DFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.106 10.4a.4.4 0 01-.24-.08l-1.6-1.2a.4.4 0 11.48-.64l1.262.946 2.966-4.448a.4.4 0 01.666.444l-3.2 4.8a.4.4 0 01-.334.178z",
  fill: "#428DFF"
})));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var Ecommerce = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.826 4.02a.75.75 0 00-.576-.27H5.04a.753.753 0 00-.596.293.755.755 0 00-.129.65l2.4 8.97a.75.75 0 00.725.557c.012 0 .025 0 .037-.002l14.31-.72a.752.752 0 00.7-.613l1.5-8.25a.745.745 0 00-.161-.615z",
  fill: "#FFC107"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.75 11.25a.75.75 0 01-.75-.75v-3a.75.75 0 011.5 0v3a.75.75 0 01-.75.75zM14.25 11.25a.75.75 0 01-.75-.75v-3a.75.75 0 011.5 0v3a.75.75 0 01-.75.75zM9.75 11.25A.75.75 0 019 10.5v-3a.75.75 0 011.5 0v3a.75.75 0 01-.75.75z",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.75 23.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM18.75 23.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM20.25 17.25h-12a.748.748 0 01-.725-.557L3.67 2.25H.75a.75.75 0 010-1.5h3.495c.34 0 .637.228.724.556L8.826 15.75H20.25a.75.75 0 010 1.5z",
  fill: "#455A64"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var Integrations = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 21.25h1.5v2h-1.5v-2z",
  fill: "#90A4AE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 21.25h-.75v2H18v-2z",
  fill: "#7D8F97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.75 10.25h-1.5v-2h1.5v2z",
  fill: "#90A4AE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8.25h-.75v2H6v-2z",
  fill: "#7D8F97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.25 24h-2.5a.75.75 0 010-1.5h2.5a.75.75 0 010 1.5z",
  fill: "#90A4AE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 6H15a1 1 0 010-2h.5a1 1 0 010 2zM17.961 6.722a.994.994 0 00-.257-.432 1 1 0 111.405-1.423c.365.36.632.811.773 1.302a.999.999 0 11-1.92.553zM19 11a1 1 0 01-1-1v-.5a1 1 0 012 0v.5a1 1 0 01-1 1zM9 20h-.5a1 1 0 010-2H9a1 1 0 010 2zM4.89 19.132a2.994 2.994 0 01-.773-1.302.999.999 0 111.922-.552.994.994 0 00.257.432 1 1 0 11-1.406 1.422zM5 15.5a1 1 0 01-1-1V14a1 1 0 012 0v.5a1 1 0 01-1 1z",
  fill: "#2196F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.25 21.5h-8.5c-.965 0-1.75-.785-1.75-1.75v-5c0-.965.785-1.75 1.75-1.75h8.5c.965 0 1.75.785 1.75 1.75v5c0 .965-.785 1.75-1.75 1.75z",
  fill: "#607D8B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 20h-8a.5.5 0 01-.5-.5V15a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v4.5a.5.5 0 01-.5.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 8.5h-8.5C.785 8.5 0 7.715 0 6.75v-5C0 .785.785 0 1.75 0h8.5C11.215 0 12 .785 12 1.75v5c0 .965-.785 1.75-1.75 1.75z",
  fill: "#607D8B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 7H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v4.5a.5.5 0 01-.5.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 0H1.75C.785 0 0 .785 0 1.75v5C0 7.715.785 8.5 1.75 8.5H6V7H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h4V0z",
  fill: "#546D79"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 1.5H2a.5.5 0 00-.5.5v4.5A.5.5 0 002 7h4V1.5z",
  fill: "#DEDEDE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 11h-2.5a.75.75 0 010-1.5h2.5a.75.75 0 010 1.5z",
  fill: "#90A4AE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10.25H4c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75z",
  fill: "#7D8F97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 13h-4.25c-.965 0-1.75.785-1.75 1.75v5c0 .965.785 1.75 1.75 1.75H18V20h-4a.5.5 0 01-.5-.5V15a.5.5 0 01.5-.5h4V13z",
  fill: "#546D79"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 14.5h-4a.5.5 0 00-.5.5v4.5a.5.5 0 00.5.5h4v-5.5z",
  fill: "#DEDEDE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 23.25h-4c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75z",
  fill: "#7D8F97"
})));

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var Telecom = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.458 7.783l1.278-1.149a.654.654 0 000-.994.845.845 0 00-1.106 0l-1.277 1.148-5.27-4.74a.845.845 0 00-1.106 0C7.55 4.23 6.75 7.578 7.905 10.528c-.747.633-1.215 1.53-1.215 2.525 0 .618.182 1.199.498 1.702l-2.136 4.751H3.499C2.12 19.506 1 20.514 1 21.753c0 1.24 1.12 2.248 2.499 2.248h14.107c1.378 0 2.499-1.008 2.499-2.248 0-1.239-1.121-2.247-2.499-2.247h-1.553l-1.73-3.904c.642.127 1.298.19 1.959.19.565 0 1.134-.046 1.698-.14 1.794-.3 3.412-1.06 4.678-2.198a.67.67 0 00.23-.497.67.67 0 00-.23-.497l-5.2-4.677zm-5.028 6.46l-.02.024c-.418.517-1.095.853-1.858.853-1.267 0-2.298-.927-2.298-2.067 0-1.14 1.031-2.068 2.298-2.068 1.268 0 2.299.928 2.299 2.068 0 .443-.156.853-.421 1.19zm6.111 7.51c0 .464-.42.842-.935.842H3.5c-.516 0-.936-.378-.936-.841 0-.464.42-.842.936-.842h14.107c.516 0 .935.378.935.841zM6.738 19.506l1.618-3.598c.624.39 1.381.618 2.196.618a4.14 4.14 0 002.217-.631l1.601 3.611H6.738zM20.97 12.93a7.752 7.752 0 01-3.275 1.339 8.484 8.484 0 01-3.472-.138c.124-.34.191-.702.191-1.078 0-1.916-1.732-3.474-3.862-3.474-.447 0-.876.07-1.276.196-.724-2.144-.238-4.496 1.284-6.208l10.41 9.363z",
  fill: "#000",
  stroke: "#fff",
  strokeWidth: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.38 3.964c1.22 0 2.213.893 2.213 1.991 0 .389.35.703.782.703.432 0 .782-.314.782-.703 0-1.873-1.695-3.397-3.778-3.397-.431 0-.781.314-.781.703 0 .388.35.703.781.703z",
  fill: "#68D4F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.38 0c-.432 0-.782.315-.782.703 0 .388.35.703.781.703 2.789 0 5.058 2.04 5.058 4.549 0 .388.35.703.781.703.432 0 .782-.315.782-.703C25 2.671 22.03 0 18.38 0z",
  fill: "#68D4F8"
})));

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var CustomerSupport = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#7795F8",
  d: "M1.043 9h3.432v8.4H1.043zM19.574 9h3.432v8.4h-3.432z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.391 8.21C21.391 3.676 17.187 0 12 0S2.609 3.676 2.609 8.21C1.268 8.356 0 9.122 0 10.9v4.288c0 2.007 1.607 2.737 3.13 2.737h1.513c.289 0 .522-.204.522-.456v-8.83c0-.252-.233-.457-.522-.457h-.99C3.652 4.152 7.39.885 12 .885c4.61 0 8.348 3.267 8.348 7.297h-.991c-.289 0-.522.205-.522.457v8.816c0 .252.233.456.521.456h.992c-.146 3.133-1.868 3.868-5.306 4v-.306c0-.503-.467-.912-1.044-.912h-3.281c-.577 0-1.044.409-1.044.912v1.483c0 .504.467.912 1.043.912h3.293c.576 0 1.043-.408 1.043-.912v-.265c3.308-.132 6.167-.73 6.34-4.94 1.34-.145 2.608-.912 2.608-2.69v-4.288c0-1.788-1.263-2.55-2.609-2.695zm-17.27.853v7.936H3.105c-.772 0-2.087-.237-2.087-1.824v-4.288c0-1.573 1.3-1.824 2.087-1.824h1.018zm9.888 13.336v.693h-3.293V21.61h3.293v.79zm8.947-7.21c0 1.573-1.299 1.823-2.086 1.823h-.992V9.095h1.018c.772 0 2.087.237 2.087 1.824l-.027 4.27z",
  fill: "#030135"
})));

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var Banking = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F6A400",
  d: "M1.321 20.484h21.5v2.625h-21.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.588 8.949A1.41 1.41 0 0024 7.542V5.721a1.4 1.4 0 00-.885-1.305L12.53.103a1.41 1.41 0 00-1.053-.002L.885 4.416A1.4 1.4 0 000 5.72v1.821A1.41 1.41 0 001.412 8.95h.847v10.597h-.847A1.41 1.41 0 000 20.952v1.641A1.41 1.41 0 001.412 24h21.176A1.41 1.41 0 0024 22.593v-1.64a1.41 1.41 0 00-1.412-1.407h-.847V8.949h.847zm0 12.003c.001 1.679.005 1.641 0 1.641H1.412v-1.64h21.176zM3.671 19.546V8.949h1.6v10.597h-1.6zm3.011 0V8.949h3.106v10.597H6.682zm4.518 0V8.949h1.6v10.597h-1.6zm3.012 0V8.949h3.106v10.597h-3.106zm4.517 0V8.949h1.6v10.597h-1.6zM1.412 7.542c0-1.962-.002-1.82.005-1.823L12 1.407 22.583 5.72c.008.003.005-.134.005 1.823H1.412z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.041a.705.705 0 00-.706.703v1.5c0 .39.316.704.706.704.39 0 .706-.315.706-.703v-1.5A.705.705 0 0012 3.04z",
  fill: "#F6A400"
})));

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var OTT = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "128",
  height: "128",
  viewBox: "0 0 96 96"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M57.5 6.9l-4 .6v47h34l.3-23.6.2-23.6-3.1-.7c-3.8-.7-21.8-.6-27.4.3zm29 3.3c.3 1.3.4 9.3.3 17.8l-.3 15.5-15.7.3-15.8.3V8h15.5c15.2 0 15.5 0 16 2.2zm.3 38.4c.5 5-1 5.5-16.9 5.2l-14.4-.3-.3-2.8c-.7-5.8-.6-5.8 16-5.5l15.3.3.3 3.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8 16.5c-8.2 4.6-5.7 16.9 3.8 18.2 3.3.4 4.5.1 7.2-2.2 2.8-2.3 3.2-3.3 3.2-7.4 0-3.7-.5-5.2-2.4-7-3-2.8-8.3-3.6-11.8-1.6zm10.7 3c3.3 3.2 3.3 7.8 0 11-7.4 7.5-18.7-3.3-11.5-11 3.2-3.4 8.2-3.4 11.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 25c0 4.6 1.4 5.1 5.1 2l2.4-2-2.4-2c-3.7-3.1-5.1-2.6-5.1 2zm3.2 1.2c-.9.9-1.2.7-1.2-1.2s.3-2.1 1.2-1.2c.9.9.9 1.5 0 2.4zM69.3 49.7c.9.2 2.5.2 3.5 0 .9-.3.1-.5-1.8-.5-1.9 0-2.7.2-1.7.5zM30.8 13.6c-3.8 2-3.6 3.9.2 1.9 3.8-2 9.4-1.9 12.6.1 1.3.9 2.7 1.4 3 1.1.4-.3-.9-1.5-2.7-2.6-4-2.4-9.3-2.6-13.1-.5zM32.8 18.1c-3.1 1.8-1.9 3 1.2 1.4 2.8-1.4 3.4-1.4 6-.1 3.3 1.6 4.2.3 1.1-1.4-2.5-1.3-6.1-1.2-8.3.1zM34.5 23c-.4.6.7 1 2.5 1s2.9-.4 2.5-1c-.3-.6-1.5-1-2.5-1s-2.2.4-2.5 1zM13.8 29.1C12.2 30 12 32.2 12 51c0 18.3-.2 21-1.5 21S9 73.2 9.2 78.7l.3 6.8 34.4.3c24.5.2 34.8-.1 35.7-.9 2-1.7 1.9-12.9-.1-12.9-1.2 0-1.5-1.5-1.7-6.8l-.1-6.7-.6 6.5-.6 6.5-31.7.3L13 72V52.2c0-14.1.3-20.1 1.2-21 .8-.8 5.2-1.2 12.8-1.3 6.3-.1 14.2-.5 17.5-.9 4.4-.5 1.3-.7-11.5-.8-10.3-.1-18.2.3-19.2.9zM37.3 76c.5 1.8 1.4 2 7.6 2 6.4 0 7.1-.2 7.1-2 0-1.9.7-2 14-2h14v3.6c0 1.9-.5 4.4-1 5.5-1 1.8-2.5 1.9-33.8 1.9-24.2 0-33.1-.3-34-1.2-.7-.7-1.2-3.1-1.2-5.5V74h13.4c12.5 0 13.4.1 13.9 2zm13.5-.8c-.3.8-2.7 1.4-6.1 1.6-4.6.2-5.7 0-5.7-1.3 0-1.2 1.3-1.5 6.1-1.5 4.4 0 6 .3 5.7 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 35.3c-.2.7-.3 8.2-.2 16.7l.3 15.5 26.3.3L71 68l-.2-4.7c-.1-4.4-.2-4.5-.5-1.1l-.4 3.8H19V36l13.3-.1c7.2-.1 14.3-.5 15.7-.9 1.5-.5-3.8-.8-13.3-.9-12-.1-15.9.2-16.3 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6 43.6c-2 2.1-2.6 3.7-2.6 6.9 0 5.9 3.6 9.5 9.5 9.5 3.2 0 4.8-.6 6.9-2.6 2-2.1 2.6-3.7 2.6-6.9 0-5.9-3.6-9.5-9.5-9.5-3.2 0-4.8.6-6.9 2.6zm11.8.6c1.5 1.3 2.9 3.7 3.2 5.5.5 2.7.1 3.7-2.4 6.3-3.9 3.9-7.4 3.9-11.3.1-3.8-3.8-3.8-7.4 0-11.2 3.5-3.5 7.1-3.7 10.5-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 50.5c0 5.1.6 5.4 4.5 2.3l2.8-2.2-2.7-2.3C33.8 45 33 45.4 33 50.5zm4 .6c0 .5-.7.9-1.5.9-.9 0-1.2-.6-.9-1.5.6-1.5 2.4-1.1 2.4.6z"
})));

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var Globe = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.162 4.234A9.98 9.98 0 0010 0h-.025l-.034.001a9.985 9.985 0 00-8.103 4.233A9.942 9.942 0 000 10c0 2.146.682 4.135 1.838 5.766a9.983 9.983 0 008.104 4.233h.057a9.981 9.981 0 008.163-4.233 9.942 9.942 0 001.837-5.767 9.942 9.942 0 00-1.837-5.765zM7.077 1.3c-.92.886-1.683 2.182-2.21 3.737A9.538 9.538 0 012.98 4.1a9.204 9.204 0 014.097-2.798zM2.499 4.727c.621.415 1.34.778 2.135 1.077a15.938 15.938 0 00-.547 4.111H.822A9.126 9.126 0 012.5 4.727zM.853 10.736h3.25c.053 1.228.24 2.394.53 3.46-.795.3-1.513.662-2.134 1.078a9.117 9.117 0 01-1.646-4.538zm2.13 5.163a9.592 9.592 0 011.884-.938c.526 1.556 1.29 2.851 2.21 3.738a9.2 9.2 0 01-4.094-2.8zm6.607 3.25c-1.684-.23-3.137-1.957-3.961-4.444a15.167 15.167 0 013.96-.607v5.051zm0-5.87a15.626 15.626 0 00-4.191.656 15.214 15.214 0 01-.475-3.199H9.59v2.543zm0-3.364H4.907c.008-1.378.187-2.68.495-3.85 1.263.387 2.682.62 4.187.656v3.194zm0-4.014a15.144 15.144 0 01-3.959-.606C6.455 2.81 7.907 1.081 9.59.85v5.051zm9.586 4.014h-3.311a15.931 15.931 0 00-.543-4.095c.813-.302 1.546-.67 2.179-1.093a9.128 9.128 0 011.675 5.188zM17.018 4.1a9.578 9.578 0 01-1.93.954c-.53-1.577-1.306-2.888-2.239-3.778A9.204 9.204 0 0117.02 4.1zM10.41.856c1.665.257 3.1 1.983 3.914 4.452a15.17 15.17 0 01-3.914.593V.856zm0 5.865a15.653 15.653 0 004.142-.642c.307 1.167.485 2.464.492 3.837H10.41V6.72zm0 4.015h4.617a15.28 15.28 0 01-.47 3.186 15.656 15.656 0 00-4.146-.643v-2.543zm0 8.407V14.1c1.411.034 2.74.245 3.917.593-.816 2.47-2.252 4.194-3.917 4.451zm2.44-.419c.932-.89 1.71-2.2 2.24-3.777.72.266 1.369.587 1.927.952a9.208 9.208 0 01-4.168 2.825zm4.65-3.45a10.503 10.503 0 00-2.178-1.094c.288-1.062.473-2.222.525-3.444h3.299a9.103 9.103 0 01-1.645 4.538z",
  fill: "#1B1B1B"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var Mortgage = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 24a11.922 11.922 0 01-8.485-3.515A11.921 11.921 0 010 12c0-3.205 1.248-6.219 3.515-8.485A11.921 11.921 0 0112 0c3.205 0 6.219 1.248 8.485 3.515A11.922 11.922 0 0124 12c0 3.205-1.248 6.219-3.515 8.485A11.92 11.92 0 0112 24zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.25a1.877 1.877 0 01-1.875-1.875c0-1.034.841-1.875 1.875-1.875s1.875.841 1.875 1.875a.75.75 0 001.5 0 3.38 3.38 0 00-2.625-3.29V5.25a.75.75 0 00-1.5 0v.835a3.38 3.38 0 00-2.625 3.29A3.379 3.379 0 0012 12.75c1.034 0 1.875.841 1.875 1.875A1.877 1.877 0 0112 16.5a1.877 1.877 0 01-1.875-1.875.75.75 0 10-1.5 0 3.38 3.38 0 002.625 3.29v.835a.75.75 0 001.5 0v-.835a3.38 3.38 0 002.625-3.29A3.379 3.379 0 0012 11.25z",
  fill: "#0056B8"
})));

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var Node = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.991 11.075V2.883h4.314M13.663 2.883h4.346v8.85",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.01 3.765h-.5a.5.5 0 00.5.5v-.5zM9.01 2v-.5a.5.5 0 00-.5.5h.5zm3.98 1.765v.5a.5.5 0 00.5-.5h-.5zm0-1.765h.5a.5.5 0 00-.5-.5V2zM2 13.998h-.5a.5.5 0 00.5.5v-.5zm0-1.766v-.5a.5.5 0 00-.5.5H2zm3.98 1.766v.5a.5.5 0 00.5-.5h-.5zm0-1.766h.5a.5.5 0 00-.5-.5v.5zm10.038 0v-.5a.5.5 0 00-.5.5h.5zm0 1.766h-.5a.5.5 0 00.5.5v-.5zM20 12.232h.5a.5.5 0 00-.5-.5v.5zm0 1.766v.5a.5.5 0 00.5-.5H20zM8.51.5a1 1 0 00-1 1h1v-1zm4.981 0H8.51v1h4.98v-1zm1 1a1 1 0 00-1-1v1h1zm0 2.765V1.5h-1v2.765h1zm-1 1a1 1 0 001-1h-1v1zm-4.98 0h4.98v-1H8.51v1zm-1-1a1 1 0 001 1v-1h-1zm0-2.765v2.765h1V1.5h-1zm2 2.265V2h-1v1.765h1zm3.48-.5H9.01v1h3.98v-1zM12.49 2v1.765h1V2h-1zm-3.48.5h3.98v-1H9.01v1zM1.5 10.732a1 1 0 00-1 1h1v-1zm4.98 0H1.5v1h4.98v-1zm1 1a1 1 0 00-1-1v1h1zm0 2.766v-2.766h-1v2.766h1zm-1 1a1 1 0 001-1h-1v1zm-4.98 0h4.98v-1H1.5v1zm-1-1a1 1 0 001 1v-1h-1zm0-2.766v2.766h1v-2.766h-1zm2 2.266v-1.766h-1v1.766h1zm3.48-.5H2v1h3.98v-1zm-.5-1.266v1.766h1v-1.766h-1zm-3.48.5h3.98v-1H2v1zm13.518-1v-1a1 1 0 00-1 1h1zm0 2.766v-2.766h-1v2.766h1zm0 0h-1a1 1 0 001 1v-1zm4.981 0h-4.98v1h4.98v-1zm0 0v1a1 1 0 001-1h-1zm0-2.766v2.766h1v-2.766h-1zm0 0h1a1 1 0 00-1-1v1zm-4.98 0h4.98v-1h-4.98v1zm0 .5v1.766h1v-1.766h-1zm4.48-.5h-3.98v1h3.98v-1zm.5 2.266v-1.766h-1v1.766h1zm-4.48.5h3.98v-1h-3.98v1z",
  fill: "#1B1B1B"
})));

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var Feedback = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.422 3.75h-.703V2.11c0-1.164-.947-2.11-2.11-2.11C17.446 0 16.5.946 16.5 2.11v.575c0 .729-.49 1.378-1.19 1.578l-.685.195v-.005a.703.703 0 00-.703-.703h-2.813a.703.703 0 00-.703.703v3.14H2.11C.946 7.594 0 8.54 0 9.704v13.594a.703.703 0 001.093.585l2.636-1.757h13.38c1.163 0 2.11-.946 2.11-2.11v-7.359h2.203A2.581 2.581 0 0024 10.078v-3.75a2.581 2.581 0 00-2.578-2.578zm-9.61 1.406h1.407v6.094h-1.406V5.156zm6 14.86a.704.704 0 01-.703.703H3.516a.703.703 0 00-.39.118l-1.72 1.146V9.703c0-.388.316-.703.703-.703h8.297v2.953c0 .388.315.703.703.703h2.813a.703.703 0 00.698-.623 3.96 3.96 0 002.129.623h1.064v7.36zm4.782-9.938c0 .646-.526 1.172-1.172 1.172h-4.673a2.56 2.56 0 01-2.124-1.136V5.92l1.071-.306a3.06 3.06 0 002.21-2.93V2.11a.704.704 0 011.407 0v2.344c0 .388.314.703.703.703h1.406c.646 0 1.172.526 1.172 1.172v3.75z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.516 13.219h4.687a.703.703 0 000-1.406H3.516a.703.703 0 000 1.406zM15.703 14.625H3.516a.703.703 0 000 1.406h12.187a.703.703 0 000-1.406zM15.703 17.438H3.516a.703.703 0 000 1.406h12.187a.703.703 0 000-1.407z",
  fill: "#E43E4C"
})));

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var NodeIndicator = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$c({
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.991 16.075V7.883h4.314M13.663 7.883h4.346v8.85",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.01 8.765h-.5a.5.5 0 00.5.5v-.5zM9.01 7v-.5a.5.5 0 00-.5.5h.5zm3.98 1.765v.5a.5.5 0 00.5-.5h-.5zm0-1.765h.5a.5.5 0 00-.5-.5V7zM2 18.997h-.5a.5.5 0 00.5.5v-.5zm0-1.765v-.5a.5.5 0 00-.5.5H2zm3.98 1.765v.5a.5.5 0 00.5-.5h-.5zm0-1.765h.5a.5.5 0 00-.5-.5v.5zm10.038 0v-.5a.5.5 0 00-.5.5h.5zm0 1.765h-.5a.5.5 0 00.5.5v-.5zM20 17.232h.5a.5.5 0 00-.5-.5v.5zm0 1.765v.5a.5.5 0 00.5-.5H20zM8.51 5.5a1 1 0 00-1 1h1v-1zm4.981 0H8.51v1h4.98v-1zm1 1a1 1 0 00-1-1v1h1zm0 2.765V6.5h-1v2.765h1zm-1 1a1 1 0 001-1h-1v1zm-4.98 0h4.98v-1H8.51v1zm-1-1a1 1 0 001 1v-1h-1zm0-2.765v2.765h1V6.5h-1zm2 2.265V7h-1v1.765h1zm3.48-.5H9.01v1h3.98v-1zM12.49 7v1.765h1V7h-1zm-3.48.5h3.98v-1H9.01v1zM1.5 15.732a1 1 0 00-1 1h1v-1zm4.98 0H1.5v1h4.98v-1zm1 1a1 1 0 00-1-1v1h1zm0 2.765v-2.765h-1v2.765h1zm-1 1a1 1 0 001-1h-1v1zm-4.98 0h4.98v-1H1.5v1zm-1-1a1 1 0 001 1v-1h-1zm0-2.765v2.765h1v-2.765h-1zm2 2.265v-1.765h-1v1.765h1zm3.48-.5H2v1h3.98v-1zm-.5-1.265v1.765h1v-1.765h-1zm-3.48.5h3.98v-1H2v1zm13.518-1v-1a1 1 0 00-1 1h1zm0 2.765v-2.765h-1v2.765h1zm0 0h-1a1 1 0 001 1v-1zm4.981 0h-4.98v1h4.98v-1zm0 0v1a1 1 0 001-1h-1zm0-2.765v2.765h1v-2.765h-1zm0 0h1a1 1 0 00-1-1v1zm-4.98 0h4.98v-1h-4.98v1zm0 .5v1.765h1v-1.765h-1zm4.48-.5h-3.98v1h3.98v-1zm.5 2.265v-1.765h-1v1.765h1zm-4.48.5h3.98v-1h-3.98v1z",
  fill: "#1B1B1B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "19",
  cy: "2",
  r: "2",
  fill: "#E43E4C"
})));

var CategoryIcons = {
  generic: Generic,
  insurance: Insurance,
  ecommerce: Ecommerce,
  integrations: Integrations,
  telecom: Telecom,
  "customer support": CustomerSupport,
  "banking sector": Banking,
  node: Node,
  nodeIndicator: NodeIndicator,
  globe: Globe,
  mortgage: Mortgage,
  feedback: Feedback,
  ott: OTT
};

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var AdvancedSearch = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$d({
  className: styles["svg-icon"] || "svg-icon",
  style: {
    verticalAlign: "middle"
  },
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  overflow: "hidden"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zm0 203.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zm581.7 190.4L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zm-385.9 12.7H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5.1 23.9-19.5 43.5-43.5 43.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5zm0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"
})));

// #region Select Wrapper
var selectWrapperStyles = function selectWrapperStyles(props) {
  var active = props.active;
  return {
    border: 0,
    maxWidth: 123,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 48,
    padding: "10px 32px 10px 10px",
    borderRadius: props.theme.radii.sm,
    position: "relative",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "> span": {
      color: props.theme.colors.blue.dark,
      fontWeight: 600,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    "*": {
      userSelect: "none"
    },
    "&:hover": {
      background: "#CFE5FF4D",
      "&:before": {
        borderColor: "transparent transparent ".concat(props.theme.colors.blue.dark, " transparent")
      }
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 0,
      height: 0,
      right: 13,
      borderStyle: "solid",
      borderWidth: "0 5px 5px 5px",
      borderColor: "transparent transparent ".concat(props.theme.colors.grey.dark, " transparent"),
      transform: "rotate(".concat(active ? "0" : "-180deg", ")"),
      transition: "all 0.2s ease"
    },
    "&:after": {
      content: '""',
      position: "absolute",
      width: 1,
      height: 32,
      right: -22,
      background: props.theme.colors.grey.haptik
    }
  };
};
var SelectWrapper = styled(Box)(selectWrapperStyles);
// #endregion

// #region Select Items
var selectItemStyles = function selectItemStyles(props) {
  var active = props.active,
    smartSkillActive = props.smartSkillActive;
  return {
    border: 0,
    textAlign: "left",
    lineHeight: 1.3,
    width: "-webkit-fill-available",
    background: active ? props.theme.colors.blue.haptik : "transparent",
    color: "".concat(active ? props.theme.colors.grey.pastel : "initial", "!important"),
    padding: !active ? "".concat(props.theme.space.xs, "px ").concat(props.theme.space.md, "px") : "".concat(props.theme.space.xs, "px 38px ").concat(props.theme.space.xs, "px ").concat(props.theme.space.md, "px"),
    alignItems: "center",
    marginBottom: 8,
    position: "relative",
    transition: "all 0.2s ease",
    cursor: "pointer",
    pointerEvents: !active ? "all" : "none",
    span: {
      zIndex: 2,
      wordBreak: "break-all",
      overflowX: "hidden",
      transform: "translateX(".concat(smartSkillActive ? "0" : "-22", "px)"),
      transition: "transform 0.3s ease"
    },
    "&:hover": {
      "&:before": {
        opacity: !active ? 1 : 0
      }
    },
    "&:before": {
      content: '""',
      transition: "opacity 0.2s ease",
      background: props.theme.colors.grey.neon,
      position: "absolute",
      width: "95%",
      height: "100%",
      left: 0,
      right: 0,
      margin: "0 auto",
      zIndex: 1,
      opacity: 0
    },
    "&:after": {
      content: '""',
      display: active ? "block" : "none",
      position: "absolute",
      top: 5,
      right: 20,
      transform: "rotate(45deg)",
      height: 13,
      width: 5,
      borderBottom: "2px solid #f5f5f5",
      borderRight: "2px solid #f5f5f5"
    },
    "&:last-child": {
      marginBottom: 0
    }
  };
};
var SelectItem = styled(Box)(selectItemStyles);
// #endregion

// #region Select Item Icon
var selectItemIconStyles = function selectItemIconStyles(props) {
  var active = props.active,
    selected = props.selected;
  return {
    transform: "translateX(".concat(active ? "0" : "-50", "px)"),
    opacity: active ? 1 : 0,
    alignItems: "center",
    position: "relative",
    transition: "all 0.2s ease",
    padding: "0 12px 0 0",
    width: 14,
    zIndex: 1,
    path: {
      fill: selected ? "white" : ""
    }
  };
};
var SelectItemIcon = styled(Box)(selectItemIconStyles);

var Select = function Select(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentSelectionData = _React$useState2[0],
    setCurrentSelectionData = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    popupActive = _React$useState4[0],
    setPopupActive = _React$useState4[1];
  var _React$useState5 = React.useState(""),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    searchTerm = _React$useState6[0],
    setSearchTerm = _React$useState6[1];
  var _React$useState7 = React.useState(Number),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    popupLeftPosition = _React$useState8[0],
    setPopupLeftPosition = _React$useState8[1];
  var _React$useState9 = React.useState(Number),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    popupTopPosition = _React$useState10[0],
    setPopupTopPosition = _React$useState10[1];
  var selectRef = React.useRef(null);
  var searchFocussed = React.useRef(false);
  var botSearchTerm = React.useRef(false);
  var triggerProps = props.triggerProps;
  var activeHeader = props.activeHeader;
  var topbarHeaderTabsID = "topbar-header-tabs";
  var publishTagStyles = {
    padding: "1px 5px",
    background: "#0DB350",
    borderRadius: 2,
    width: "fit-content",
    marginLeft: 5,
    display: "inline-flex"
  };
  var searchBarRHSStyles = {
    position: "absolute",
    zIndex: 1,
    top: 3,
    right: 12,
    width: 17,
    padding: 0
  };
  var handleSelectClick = React.useCallback(function () {
    setPopupActive(!popupActive);
  }, [popupActive]);
  React.useEffect(function () {
    if (triggerProps) setPopupActive(triggerProps.popupActive);
  }, [triggerProps]);
  React.useEffect(function () {
    setCurrentSelectionData(props.selected);
  }, [props.selected]);
  React.useEffect(function () {
    if (triggerProps && triggerProps.ref) {
      var _triggerProps$ref;
      var positions = (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || (_triggerProps$ref = _triggerProps$ref.current) === null || _triggerProps$ref === void 0 ? void 0 : _triggerProps$ref.getBoundingClientRect();
      setPopupLeftPosition((positions === null || positions === void 0 ? void 0 : positions.left) + triggerProps.left);
      setPopupTopPosition((positions === null || positions === void 0 ? void 0 : positions.top) + triggerProps.top);
    } else {
      var _selectRef$current;
      var _positions = selectRef === null || selectRef === void 0 || (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.getBoundingClientRect();
      setPopupLeftPosition((_positions === null || _positions === void 0 ? void 0 : _positions.left) - 15);
      setPopupTopPosition((_positions === null || _positions === void 0 ? void 0 : _positions.top) + 60);
    }
  }, [popupActive, triggerProps]);
  var handleSelectItemClick = function handleSelectItemClick(item) {
    props.onChange(item);
    setCurrentSelectionData(item);
  };
  var renderPublishTag = function renderPublishTag() {
    if (activeHeader) {
      return /*#__PURE__*/React.createElement(Box, {
        style: publishTagStyles
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "body.sm",
        color: "grey.pastel"
      }, "Published"));
    }
    return null;
  };
  var renderSmartSkillIcon = function renderSmartSkillIcon(icon, tooltip, selected) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      themed: true,
      size: "small",
      tooltip: tooltip,
      offset: {
        left: -5
      }
    }, /*#__PURE__*/React.createElement(SelectItemIcon, {
      active: activeHeader,
      selected: selected
    }, /*#__PURE__*/React.createElement(Icon, {
      src: icon
    })));
  };
  var renderSelectItemText = function renderSelectItemText(isActive, text, isPublished) {
    return /*#__PURE__*/React.createElement(Text, {
      variant: "body.lg",
      color: isActive ? "grey.pastel" : "initial"
    }, text, isPublished && renderPublishTag());
  };
  var renderSelectItems = React.useMemo(function () {
    var retData = [];
    if (props.optionsToShow && !searchTerm) {
      props.options.slice(0, props.optionsToShow).forEach(function (item, i) {
        var tag = item.tags ? item === null || item === void 0 ? void 0 : item.tags[0].toLowerCase() : "";
        var isActive = item.id.toLowerCase() === (currentSelectionData === null || currentSelectionData === void 0 ? void 0 : currentSelectionData.id.toLowerCase());
        retData.push( /*#__PURE__*/React.createElement(SelectItem, {
          key: "topbar-select-".concat(i),
          "data-testid": "tooltip-iva-select-item-".concat(item.title),
          active: isActive,
          smartSkillActive: activeHeader,
          onClick: function onClick() {
            return handleSelectItemClick(item);
          }
        }, renderSmartSkillIcon(CategoryIcons[tag], item.tags && (item === null || item === void 0 ? void 0 : item.tags[0]), isActive), renderSelectItemText(isActive, item.title || item.name, item.active // If Smart Skill is published or not
        )));
      });
    } else {
      props.options.forEach(function (item, i) {
        var tag = item.tags ? item === null || item === void 0 ? void 0 : item.tags[0].toLowerCase() : "";
        var isActive = item.id.toLowerCase() === (currentSelectionData === null || currentSelectionData === void 0 ? void 0 : currentSelectionData.id.toLowerCase());
        if (searchTerm) {
          if (item[props.searchKey].toLowerCase().includes(searchTerm.toLowerCase())) {
            retData.push( /*#__PURE__*/React.createElement(SelectItem, {
              key: "topbar-select-".concat(i),
              "data-testid": "tooltip-iva-select-item-".concat(item.title),
              active: isActive,
              smartSkillActive: activeHeader,
              onClick: function onClick() {
                return handleSelectItemClick(item);
              }
            }, renderSmartSkillIcon(CategoryIcons[tag], item.tags && (item === null || item === void 0 ? void 0 : item.tags[0]), isActive), renderSelectItemText(isActive, item.title || item.name, item.active // If Smart Skill is published or not
            )));
          }
        } else {
          retData.push( /*#__PURE__*/React.createElement(SelectItem, {
            key: "topbar-select-".concat(i),
            "data-testid": "tooltip-iva-select-item-".concat(item.title),
            active: isActive,
            smartSkillActive: activeHeader,
            onClick: function onClick() {
              return handleSelectItemClick(item);
            }
          }, renderSmartSkillIcon(CategoryIcons[tag], item.tags && (item === null || item === void 0 ? void 0 : item.tags[0]), isActive), renderSelectItemText(isActive, item.title || item.name, item.active // If Smart Skill is published or not
          )));
        }
      });
    }
    if (retData.length === 0) {
      retData.push( /*#__PURE__*/React.createElement(Box, {
        padding: "6px 12px 4px 12px"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "body.lg"
      }, "No result found")));
    }
    return retData;
  }, [currentSelectionData === null || currentSelectionData === void 0 ? void 0 : currentSelectionData.id, searchTerm, activeHeader, props.botSearchResultsLoading, props.options]);
  var handleSearch = debounce(function (searchTerm) {
    if (activeHeader) {
      setSearchTerm(searchTerm);
    } else {
      setSearchTerm("");
      botSearchTerm.current = searchTerm;
      props.handleBotSearch(searchTerm);
    }
  }, 500);
  var renderHeader = React.useMemo(function () {
    return /*#__PURE__*/React.createElement(Box, {
      flexDirection: "column",
      padding: "0",
      width: "100%"
    }, props.currScreen === CONSTANTS.BB && props.canModifySmartSkill && /*#__PURE__*/React.createElement(Box, {
      padding: "0",
      marginBottom: "16px",
      id: topbarHeaderTabsID
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        position: "fixed",
        width: "100%",
        height: 1,
        background: "#D5D5D5",
        top: "49px",
        left: 0,
        padding: 0
      }
    }), /*#__PURE__*/React.createElement(Action, {
      visible: true,
      active: !activeHeader,
      mode: "tab",
      style: {
        marginRight: 12,
        transform: "translateY(-4px)"
      },
      onClick: function onClick() {
        return props.setActiveHeader(0);
      },
      "data-testid": "topbar-popup-bot"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "body.lg",
      color: !activeHeader ? "blue.haptik" : "black.haptik"
    }, "Bots")), /*#__PURE__*/React.createElement(Action, {
      visible: true,
      active: activeHeader,
      mode: "tab",
      "data-testid": "topbar-popup-smartSkill",
      onClick: function onClick() {
        return props.setActiveHeader(1);
      },
      style: {
        transform: "translateY(-4px)"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "body.lg",
      color: activeHeader ? "blue.haptik" : "black.haptik"
    }, "Smart Skills"))), props.search && /*#__PURE__*/React.createElement(Box, {
      padding: "zero",
      style: {
        position: "relative",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "zero",
      style: {
        position: "absolute",
        zIndex: 1,
        top: 9,
        left: 10
      }
    }, /*#__PURE__*/React.createElement(SearchIconV2$1, {
      size: "small",
      iconColor: "grey.deep"
    })), /*#__PURE__*/React.createElement(Text$1, {
      themed: true,
      placeholder: "Search from ".concat(activeHeader ? props.options.length : props.botCount, " ").concat(activeHeader ? "smart skills" : "bots"),
      onChange: handleSearch,
      style: {
        paddingLeft: 36,
        width: activeHeader ? "83%" : "100%"
      },
      onFocus: function onFocus() {
        searchFocussed.current = true;
      },
      onBlur: function onBlur() {
        searchFocussed.current = false;
      }
    }), props.botSearchResultsLoading && !activeHeader && /*#__PURE__*/React.createElement(Box, {
      style: searchBarRHSStyles
    }, /*#__PURE__*/React.createElement(Loader, null)), activeHeader ? /*#__PURE__*/React.createElement(Tooltip, {
      themed: true,
      tooltip: "Advanced Search",
      offset: {
        left: -20,
        top: -8
      }
    }, /*#__PURE__*/React.createElement(Box, {
      onClick: function onClick() {
        window.location.href = ROUTES.SMART_SKILLS;
      },
      style: _objectSpread2(_objectSpread2({}, searchBarRHSStyles), {}, {
        cursor: "pointer",
        top: 0,
        right: 0,
        width: 27,
        height: 30,
        borderRadius: 3,
        padding: "4px 5px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#CFE5FF"
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      src: AdvancedSearch
    }))) : null));
  }, [props.activeHeader, props.currScreen, props.botSearchResultsLoading, props.botCount]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !triggerProps && /*#__PURE__*/React.createElement(SelectWrapper, {
    "data-testid": "topbar-iva-select",
    onClick: handleSelectClick,
    active: popupActive,
    ref: selectRef
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body.lg",
    color: "blue.dark"
  }, (currentSelectionData === null || currentSelectionData === void 0 ? void 0 : currentSelectionData.name) || (currentSelectionData === null || currentSelectionData === void 0 ? void 0 : currentSelectionData.title))), /*#__PURE__*/React.createElement(Popup, {
    active: popupActive,
    position: {
      left: popupLeftPosition,
      top: popupTopPosition
    },
    containerRef: triggerProps ? triggerProps.ref : selectRef,
    onActiveChange: function onActiveChange(active) {
      !active && !searchFocussed.current && setSearchTerm("");
      if (!active) {
        if (botSearchTerm.current && !searchFocussed.current) {
          botSearchTerm.current = "";
          props.handleBotSearch("");
        }
      }
      !searchFocussed.current && setPopupActive(active);
      !active && triggerProps && triggerProps.onClose && triggerProps.onClose();
    },
    header: renderHeader,
    footer: props.footer,
    footerProps: props.footerProps,
    variant: "select",
    mode: "smartSkill",
    preventCloseOn: topbarHeaderTabsID,
    width: 297 // From design
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    width: "100%",
    padding: "0 8px"
  }, props.options.length > 0 && renderSelectItems)));
};
Select.propTypes = {
  search: PropTypes.bool,
  searchKey: PropTypes.string,
  optionsToShow: PropTypes.number,
  footer: PropTypes.bool,
  footerProps: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  selected: PropTypes.object,
  triggerProps: PropTypes.object,
  activeHeader: PropTypes.number,
  setActiveHeader: PropTypes.func,
  currScreen: PropTypes.string,
  botCount: PropTypes.number,
  handleBotSearch: PropTypes.func,
  botSearchResultsLoading: PropTypes.bool,
  canModifySmartSkill: PropTypes.bool
};

export { APIRequest as A, Select as S, Action as a, getEnvURL as b, getDataFromLocalStorage as g, mixPanelPayload as m, updateLocalStorage as u };
